
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { State } from "../../types/State";
import { GetPromoData, NavigateToSlide, SetSliderRef } from "../Actions/ActionPromo";
import ViewPromo from "../Components/ViewPromo/ViewPromo";
import { playButtonSound, playScreenChangeSound } from "../web2ClientAPI/web2ClientAPI";
import { ClanRecIsEnabled, ClanRec2IsEnabled } from 'helpers/common'

export type ContainerPromo_Props = {
  SetSliderRef: (ref: any) => void;
  NavigateToSlide: (index: number) => void;
  GetPromoData: () => void;

  router: any;
  promoInitialSlide: number;
  clanId: number | null;
  root: string;
  buildings: any;
};
export type ContainerPromo_State = {
  activeSlide: number;
};

class ContainerPromo extends PureComponent<ContainerPromo_Props, ContainerPromo_State> {


  constructor(props) {
    super(props);

    this.state = {
      activeSlide: 0
    };
  }

  componentDidMount() {
    this.props.GetPromoData();
  }

  goToFirstSlide = () => {
    playButtonSound();
    playScreenChangeSound();
    this.props.NavigateToSlide(0);
  };

  goToSecondSlide = () => {
    playButtonSound();
    playScreenChangeSound();
    this.props.NavigateToSlide(1);
  };

  navigateToRecommendations = () => {
    const url = ClanRec2IsEnabled ? 'new-recommendations' : 'recommendations'
    this.props.router.push(this.props.root + url)
  }

  beforeChange = (curIndex: any, nextIndex: number) => {
    if (nextIndex !== null && nextIndex !== undefined) {
      this.props.NavigateToSlide(nextIndex);
    }
  };

  afterChange = (index: number) => {
    this.setState({
      activeSlide: index
    });
  };

  render() {
    return (
      <ViewPromo
        {...this.props}
        goToFirstSlide={this.goToFirstSlide}
        goToSecondSlide={this.goToSecondSlide}
        navigateToRecommendations={this.navigateToRecommendations}
        beforeChange={this.beforeChange}
        afterChange={this.afterChange}
        activeSlide={this.state.activeSlide} />
    )
  }
}

const mapStateToProps = (state: State) => ({
  promoInitialSlide: state.ReducerPromo.promoInitialSlide,
  clanId: state.currentAccount.clanId,
  root: state.urls.root,
  buildings: state.ReducerSupply.buildings
});

const mapDispatchToProps = dispatch => {
  return {
    SetSliderRef: ref => {
      dispatch(SetSliderRef(ref));
    },
    NavigateToSlide: (index: number) => {
      dispatch(NavigateToSlide(index));
    },
    GetPromoData: () => {
      dispatch(GetPromoData());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContainerPromo);